<lib-suivi-demandes-adhesion [IS_GESTION_SALARIE_V2]="configuration.IS_GESTION_SALARIE_V2"  [configuration]="configuration"  ></lib-suivi-demandes-adhesion>
